import list from './halfDragonTemplateList'
import generator from './halfDragonTemplateGenerator'

export default list.map(generator)
